export default __webpack_public_path__ + "assets/images/g-icon3-55e59ec5.svg";